import { useNavigate } from 'react-router-dom';
import { useHeaderIndicatorsQuery } from '../../hooks/queries';

export function UnassignedIndicator() {
  const navigate = useNavigate();
  const { data } = useHeaderIndicatorsQuery();
  const unassignedCount = data?.unassignedCount ?? 0;

  if (unassignedCount <= 0) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => navigate('/incidents?unassigned=true')}
      className="relative p-2 rounded-lg text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
      aria-label={`Unassigned incidents (${unassignedCount})`}
      title={`Unassigned incidents: ${unassignedCount}`}
    >
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M18 9a3 3 0 11-6 0 3 3 0 016 0zm-9 0a3 3 0 11-6 0 3 3 0 016 0zm9 10v-1a4 4 0 00-4-4h-2m-6 5v-1a4 4 0 014-4h2"
        />
      </svg>
      <span className="absolute -top-1 -right-1 min-w-4 h-4 px-1 rounded-full bg-blue-500 text-[10px] font-bold text-white flex items-center justify-center">
        {unassignedCount > 99 ? '99+' : unassignedCount}
      </span>
    </button>
  );
}

